import React, { Component } from "react";
import PropTypes from "prop-types";

import "css/common/modal.scss";

export class ModalConfirmUI extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  onOpen = () => {
    this.setState({
      isOpen: true,
    });
  };

  onClose = () => {
    const { onClose } = this.props;
    this.setState({
      isOpen: false,
    });
    onClose && onClose();
  };

  onSubmit = () => {
    this.onClose();
    this.props.onConfirm();
  };

  handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  getModal = () => {
    const { open, body, body_2, confirmText, cancelText, title } = this.props;

    const { isOpen } = this.state;

    if (isOpen || open) {
      document.body.classList.add("modal-open");
      return (
        <div
          className="modal-container"
          onClick={() => this.onClose()}
          data-testid="ModalConfirm-content"
        >
          <div className="modal-box" onClick={(e) => this.handleClick(e)}>
            <div className="modal-title">{title}</div>
            <div className="modal-body" data-testid="ModalConfirm-body">
              {body}
              {body_2}
            </div>
            <div className="modal-btn">
              {cancelText && (
                <button
                  className="btn"
                  onClick={() => this.onClose()}
                  data-testid="ModalConfirm-cancel"
                >
                  {cancelText}
                </button>
              )}
              {confirmText && (
                <button
                  className="btn"
                  onClick={() => this.onSubmit()}
                  data-testid="ModalConfirm-confirm"
                >
                  {confirmText}
                </button>
              )}
            </div>
          </div>
        </div>
      );
    }
    document.body.classList.remove("modal-open");
    return (
      <div className="modal-container-hide" data-testid="ModalConfirm-hide" />
    );
  };

  render() {
    const { children } = this.props;

    return (
      <div className="modal-container-parent" data-testid="ModalConfirm">
        {this.getModal()}
        <div
          className="modal-children"
          onClick={() => this.onOpen()}
          data-testid="ModalConfirm-children"
        >
          {children}
        </div>
      </div>
    );
  }
}

ModalConfirmUI.propTypes = {
  open: PropTypes.bool,
  onConfirm: PropTypes.func,
  onClose: PropTypes.func,
  body: PropTypes.string.isRequired,
  body_2: PropTypes.node,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default ModalConfirmUI;
